import React from 'react';
import {
  FormAutocomplete,
  FormTextArea,
  FormTextField,
  FormPanel,
  FormCustomField,
  useFormSelector,
  FormDateField,
  FormCheckbox,
  TextArea,
} from '@eas/common-web';
import { useDictionaryBoilerBrands } from '../dict-boiler-brand/dict-boiler-brands-api';
import { useDictionaryBoilerTypes } from '../dict-boiler-type/dict-boiler-types-api';
import { EvidenceUrl } from '../../enums';
import { DictionaryBoilerModel } from '../../models';
import { DetailNavigationButton } from '../../components/detail-navigation-button/detail-navigation-button';
import { HistoryEvidenceFieldsProps } from '../../components/evidence/history-evidence/history-types';

export function DictionaryBoilerModelsFields(
  props: HistoryEvidenceFieldsProps
) {
  const boilerBrands = useDictionaryBoilerBrands();
  const boilerTypes = useDictionaryBoilerTypes();
  const { manufacturer } = useFormSelector((data: DictionaryBoilerModel) => ({
    manufacturer: data.manufacturer,
  }));

  return (
    <>
      <FormPanel label="Základní informace">
        <FormTextField name="name" label="Název" />
        <FormAutocomplete name="brand" label="Značka" source={boilerBrands} />
        <FormAutocomplete
          name="types"
          multiple={true}
          label="Typy kotle"
          source={boilerTypes}
          DisabledComponent={TextArea}
        />
        <FormCheckbox name="active" label="Aktivní" />
        <FormDateField
          name="validFrom"
          label="Platný od"
          representation="instant"
        />
        <FormDateField
          name="validTo"
          label="Platný do"
          representation="instant"
        />
        <FormTextArea name="description" label="Popis" />
      </FormPanel>
      <FormPanel label="Výrobce">
        <FormTextField name="manufacturer.subject.name" label="Název" />
        <FormCustomField>
          <DetailNavigationButton
            url={EvidenceUrl.BOILER_MANUFACTURERS}
            id={manufacturer?.id}
          />
        </FormCustomField>
      </FormPanel>
      {props.HistoryRecords}
    </>
  );
}
